<div class="max-w-[60rem] mx-auto w-full">
  <router-outlet></router-outlet>
</div>
